const $ = jQuery;

export default {
    init() {
        setupInsightsCarousel();
    }
};

function setupInsightsCarousel() {
    const $blocks = $('.page-block-insights-carousel');

    if (!$blocks.length) return;

    $blocks.each(function() {
        const $container = $(this);
        const $slider = $container.find('.insights-slider');
        const $prevArrow = $container.find('.insights-prev-custom');
        const $nextArrow = $container.find('.insights-next-custom');

        if ($slider.hasClass('slick-initialized')) return;

        $slider.slick({
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1,
            arrows: true,
            prevArrow: $prevArrow,
            nextArrow: $nextArrow,
            swipeToSlide: true,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 3,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 2,
                    }
                },
                {
                    breakpoint: 640,
                    settings: {
                        slidesToShow: 1,
                    }
                }
            ]
        });
    });
}
